import useAsyncData from "../../../hooks/use-async-data";
import planEntryService from "../plan-entry.service";
import PlanEntryActiveList from "./plan-entry-active-list";
import PlanEntryActiveListParams from "./plan-entry-active-list-params";

const usePlanEntryActiveList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<PlanEntryActiveList>({
      data: [],
    });

  const load = async (
    params: PlanEntryActiveListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderActiveList = await planEntryService.getActiveList(
        params,
        signal,
      );

      setData(cargoOrderActiveList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default usePlanEntryActiveList;
